import { render, staticRenderFns } from "./IDCardUpload.vue?vue&type=template&id=626c7be8&scoped=true&"
import script from "./IDCardUpload.vue?vue&type=script&lang=ts&"
export * from "./IDCardUpload.vue?vue&type=script&lang=ts&"
import style0 from "./IDCardUpload.vue?vue&type=style&index=0&id=626c7be8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626c7be8",
  null
  
)

export default component.exports